import { DocumentUpload as DefaultDocumentUpload } from "src/components/feature/Onboarding";

const DocumentUpload = () => {
  return <DefaultDocumentUpload />;
};

export default DocumentUpload;
